"use strict";
/*!
 *
 *  top.ts
 *
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var swiper_1 = __importDefault(require("swiper"));
var modules_1 = require("swiper/modules");
require("swiper/css");
require("swiper/css/scrollbar");
function default_1() {
    if ($('#TopHero').length) {
        new Hero();
    }
    ;
    if ($('#TopImportantSlider').length) {
        new Important();
    }
    ;
    if ($('#TopBnrs').length) {
        new Bnrs();
    }
    ;
    if ($('#TopReason').length) {
        new Reason();
    }
    ;
    if ($('#TopInterviewSlider').length) {
        new Interview();
    }
    if ($('#TopBgVideo').length) {
        new Parallax();
    }
    ;
    if ($('#TopInsta').length) {
        new Insta();
    }
    ;
    if ($('#OCModal').length) {
        new Modal();
    }
    ;
    if ($('#TopNews').length) {
        new News();
    }
}
exports.default = default_1;
;
var Hero = /** @class */ (function () {
    function Hero() {
        var _this = this;
        this.$container = $('#TopHero');
        this.$slider = $('#TopHeroSlider');
        this.$slider.on('init', function () {
            _this.$container.addClass('-init');
            setTimeout(function () {
                _this.$slider.find('.slick-active').addClass('slick-play');
            }, 1000);
        }).on('beforeChange', function (e, slick, currentSlide, nextSlide) {
            _this.$slider.find('.slick-slide').filter(function (i, elem) { return i == nextSlide; }).addClass('slick-play');
        }).on('afterChange', function () {
            _this.$slider.find('.slick-slide').not('.slick-active').removeClass('slick-play');
        });
        this.$slider.slick({
            arrows: false,
            fade: true,
            autoplay: true,
            autoplaySpeed: 5000,
            speed: 3000,
            pauseOnFocus: false,
            pauseOnHover: false
        });
    }
    return Hero;
}());
var Important = /** @class */ (function () {
    function Important() {
        this.slider = document.querySelector('#TopImportantSlider');
        new swiper_1.default(this.slider, {
            modules: [modules_1.Navigation, modules_1.Autoplay],
            slidesPerView: 'auto',
            spaceBetween: 0,
            autoHeight: true,
            direction: 'vertical',
            loop: true,
            navigation: {
                nextEl: '#TopImportantNext',
            },
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
        });
    }
    return Important;
}());
var Bnrs = /** @class */ (function () {
    function Bnrs() {
        var _this = this;
        this.slider = document.querySelector('#TopBnrs');
        this.wrapper = this.slider.querySelector('.top-banners__wrapper');
        this.items = this.wrapper.querySelectorAll('.top-banners__item');
        this.items.forEach(function (item, i) {
            _this.wrapper.appendChild(item.cloneNode(true));
        });
        new swiper_1.default(this.slider, {
            modules: [modules_1.Navigation, modules_1.Pagination, modules_1.Autoplay],
            slidesPerView: 'auto',
            centeredSlides: true,
            spaceBetween: 16,
            loop: true,
            breakpoints: {
                767: {
                    spaceBetween: 16
                },
                768: {
                    spaceBetween: 32
                }
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: false
            },
            navigation: {
                nextEl: '.top-banners__next',
                prevEl: '.top-banners__prev',
            },
            pagination: {
                el: '.top-banners__pagination',
                type: "custom",
                clickable: false,
                renderCustom: function (swiper, current, total) {
                    var halfTotal = total / 2; // 実数の半分
                    var adjustedCurrent = current % halfTotal === 0 ? halfTotal : current % halfTotal;
                    return "".concat(adjustedCurrent, " / ").concat(halfTotal);
                }
            }
        });
    }
    return Bnrs;
}());
var Reason = /** @class */ (function () {
    function Reason() {
        var _this = this;
        this.elem = document.querySelector('#TopReason');
        this.slider = this.elem.querySelector('.top-reason-slider');
        this.links = this.elem.querySelectorAll('.top-reason__link');
        this.swiper = new swiper_1.default(this.slider, {
            modules: [modules_1.Pagination],
            slidesPerView: 1,
            loop: true,
            pagination: {
                el: '.top-reason-slider__pagination',
            },
            on: {
                slideChange: function () { return _this.updateActiveClass(); },
            },
        });
        this.links.forEach(function (link, index) {
            link.addEventListener('mouseenter', function () {
                _this.swiper.slideToLoop(index);
            });
        });
        this.updateActiveClass(); // 初期状態でクラスを設定
    }
    Reason.prototype.updateActiveClass = function () {
        if (!this.swiper)
            return;
        var realIndex = this.swiper.realIndex; // `loop: true` の場合は `realIndex` を使う
        this.links.forEach(function (link, index) {
            link.classList.toggle('-active', index === realIndex);
        });
    };
    return Reason;
}());
var Interview = /** @class */ (function () {
    function Interview() {
        var _this = this;
        this.slider = document.querySelector('#TopInterviewSlider');
        new swiper_1.default(this.slider, {
            modules: [modules_1.Navigation, modules_1.Pagination, modules_1.Scrollbar],
            slidesPerView: 'auto',
            // loop: true,
            // centeredSlides: true,
            spaceBetween: 20,
            breakpoints: {
                767: {
                    spaceBetween: 20
                },
                768: {
                    spaceBetween: 40
                }
            },
            navigation: {
                nextEl: '.top-interview-slider__next',
                prevEl: '.top-interview-slider__prev',
            },
            scrollbar: {
                el: ".top-interview-slider__scrollbar",
                hide: false,
                dragSize: 20,
                draggable: true,
            },
            on: {
                slideChangeTransitionStart: function (swiper) {
                    _this.slider.dataset.current = "".concat(swiper.activeIndex);
                }
            }
        });
    }
    return Interview;
}());
var axios_1 = __importDefault(require("axios"));
global.Promise = require('es6-promise').Promise;
var Insta = /** @class */ (function () {
    function Insta() {
        this.elem = document.querySelector('#TopInsta');
        this.slider = this.elem.querySelector('.top-insta-slider');
        this.wrapper = this.elem.querySelector('.top-insta-slider__wrapper');
        this.data = [];
        // json: string = '/assets/js/test.json'
        this.json = 'https://graph.facebook.com/v10.0/17841408417730738?fields=name%2Cmedia.limit(15)%7Bcaption%2Cmedia_url%2Cthumbnail_url%2Cpermalink%2Cusername%7D&access_token=EAANTZAuA7VIgBAANXPDLld25wwhH9zsl5oAmqQi7YAkkCoxn8YPNxVqZCWVA14Tr8fT8TFWUj4FbUOtZCd0IxG1zW7DRgvWR04Rcr6BIwNZAs2RqDdC2p8gA8FZB4jZBlhzMZC8I0V8NW0IY1hMDPYUMeQHZB901YMu4uxU1pjVY4DdDqQAu6ZCFa';
        this.getInstagram();
    }
    Insta.prototype.getInstagram = function () {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axios_1.default.get(this.json)];
                    case 1:
                        res = _a.sent();
                        this.data = res.data.media.data;
                        this.build();
                        return [2 /*return*/];
                }
            });
        });
    };
    Insta.prototype.build = function () {
        var _this = this;
        var sliderItems = '';
        this.data.forEach(function (val, i) {
            sliderItems += _this.getItem(val);
        });
        this.wrapper.innerHTML = sliderItems;
        new swiper_1.default(this.slider, {
            modules: [modules_1.Autoplay],
            slidesPerView: 'auto',
            centeredSlides: true,
            loopAdditionalSlides: 2,
            loop: true,
            spaceBetween: 24,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false
            },
        });
    };
    Insta.prototype.getItem = function (item) {
        return "\n\t\t\t<a href=\"".concat(item.permalink, "\" class=\"top-insta-card swiper-slide\" aria-label=\"").concat(item.caption.replace(/(?:\r\n|\r|\n)/g, ''), "\" target=\"_blank\">\n\t\t\t\t<img src=\"").concat(item.thumbnail_url ? item.thumbnail_url : item.media_url, "\" alt=\"\" width=\"300\" height=\"300\" loading=\"lazy\">\n\t\t\t</a>\n\t\t");
    };
    return Insta;
}());
var tab_1 = __importDefault(require("tab"));
var News = /** @class */ (function () {
    function News() {
        this.elem = document.querySelector('#TopNews');
        new tab_1.default({
            elem: '.top-news-tab',
            navClass: '.top-news-tab__nav',
            cntClass: '.top-news-tab__body',
        });
    }
    return News;
}());
// class Bnrs {
// 	$elem: JQuery = $('#TopBnrs');
// 	constructor() {
// 		this.$elem.slick({
// 			slidesToShow: 1,
// 			slidesToScroll: 1,
// 			infinite: true,
// 			arrows: false,
// 			dots: true,
// 			mobileFirst: true,
// 			centerMode: true,
// 			autoplay: true,
// 			autoplaySpeed: 3000,
// 			responsive: [
// 				{
// 					breakpoint: 0,
// 					settings: {
// 						slidesToShow: 1,
// 						slidesToScroll: 1,
// 						arrows: false,
// 						centerMode: true,
// 						centerPadding: '0px',
// 						variableWidth: true
// 					}
// 				},
// 				{
// 					breakpoint: 767,
// 					settings: {
// 						slidesToShow: 3,
// 						slidesToScroll: 1,
// 						arrows: true,
// 						centerMode: false
// 					}
// 				}
// 			]
// 		});
// 		$(window).on('viewportChanged', () => {
// 			if (util.viewport === 'phone') {
// 				this.$elem.slick('init');
// 			};
// 		});
// 	}
// }
var Parallax = /** @class */ (function () {
    function Parallax() {
        this.$container = $('#TopBgVideo');
        this.base = 0;
        this.span = 0;
        this.vh = 0;
        this.ratio = 0;
        this.$bg = this.$container.children('.tp-Container_Video');
        var src = util.viewport !== 'phone' ? this.$bg.data('src') : this.$bg.data('src-sm');
        this.$bg.attr('src', src);
        // this.setParam();
        // $(window).on('scroll', () => {
        // 	let top = $(window).scrollTop();
        // 	if (top + util.wh > this.base && top < this.base + this.span) {
        // 		let y = (this.base - (top + util.wh)) * this.ratio;
        // 		this.$bg.css({
        // 			transform: 'translate(0, '+ y + 'px)'
        // 		});
        // 	};
        // }).on('resize', () => {
        // 	this.setParam();
        // });
    }
    Parallax.prototype.setParam = function () {
        this.span = this.$container.height();
        this.base = this.$container.offset().top;
        this.vh = this.$bg.height();
        this.ratio = (this.vh - this.span) / (util.wh - this.span);
    };
    return Parallax;
}());
// import axios from 'axios';
// global.Promise = require('es6-promise').Promise;
// // https://graph.facebook.com/v10.0/【ビジネスID】?fields=name%2Cmedia.limit(【最大メディア数】)%7Bcaption%2Cmedia_url%2Cthumbnail_url%2Cpermalink%2Cusername%7D&access_token=【アクセストークン】
// // テストアカウント
// // https://graph.facebook.com/v10.0/17841405865516012?fields=name%2Cmedia.limit(15)%7Bcaption%2Cmedia_url%2Cthumbnail_url%2Cpermalink%2Cusername%7D&access_token=EAAHjsQSCX7MBAEKH8UQ0GL68zZBTSKIuZChA6Mn1rJ0rI6A9eLwV0w86TUTnPTy0kF2TgNwUGuf8kWe963EdDzbch8okeoYb32GXKZCJ0ZCCgWKtvUkpgZAxPPZBpRcwfKXrMP3FaNkIfNcpJrZAxcx6T2289pOFp6J7JNoDL73P9I0AaOmH0QGZBVrZBF1ntgnIZD
// // 本アカウント
// // https://graph.facebook.com/v10.0/17841408417730738?fields=name%2Cmedia.limit(15)%7Bcaption%2Cmedia_url%2Cthumbnail_url%2Cpermalink%2Cusername%7D&access_token=EAANTZAuA7VIgBAANXPDLld25wwhH9zsl5oAmqQi7YAkkCoxn8YPNxVqZCWVA14Tr8fT8TFWUj4FbUOtZCd0IxG1zW7DRgvWR04Rcr6BIwNZAs2RqDdC2p8gA8FZB4jZBlhzMZC8I0V8NW0IY1hMDPYUMeQHZB901YMu4uxU1pjVY4DdDqQAu6ZCFa
// interface instaItem {
// 	caption?: string;
// 	thumbnail_url?: string;
// 	like_count: number;
// 	media_url: string;
// 	permalink: string;
// 	timestamp: string;
// 	username: string;
// 	id: string;
// }
// class Insta {
// 	$slider: JQuery = $('.tp-Insta_Slider');
// 	data: instaItem[] = [];
// 	// json: string = '/assets/js/test.json'
// 	json: string = 'https://graph.facebook.com/v10.0/17841408417730738?fields=name%2Cmedia.limit(15)%7Bcaption%2Cmedia_url%2Cthumbnail_url%2Cpermalink%2Cusername%7D&access_token=EAANTZAuA7VIgBAANXPDLld25wwhH9zsl5oAmqQi7YAkkCoxn8YPNxVqZCWVA14Tr8fT8TFWUj4FbUOtZCd0IxG1zW7DRgvWR04Rcr6BIwNZAs2RqDdC2p8gA8FZB4jZBlhzMZC8I0V8NW0IY1hMDPYUMeQHZB901YMu4uxU1pjVY4DdDqQAu6ZCFa'
// 	constructor() {
// 		this.getInstagram();
// 	}
// 	async getInstagram() {
// 		let res = await axios.get(this.json);
// 		this.data = res.data.media.data;
// 		this.build();
// 	}
// 	build() {
// 		let sliderItems: string = '';
// 		this.data.forEach((val: instaItem, i:number) => {
// 			sliderItems += this.getItem(val);
// 		});
// 		this.$slider.html(sliderItems);
// 		this.$slider.slick({
// 			slidesToShow: 4,
// 			slidesToScroll: 4,
// 			infinite: true,
// 			arrows: false,
// 			dots: false,
// 			mobileFirst: true,
// 			variableWidth: true,
// 			autoplay: true,
// 			autoplaySpeed: 3000,
// 			responsive: [
// 				{
// 					breakpoint: 991,
// 					settings: {
// 						slidesToShow: 4,
// 						slidesToScroll: 4
// 					}
// 				},
// 				{
// 					breakpoint: 575,
// 					settings: {
// 						slidesToShow: 3,
// 						slidesToScroll: 3,
// 						variableWidth: false,
// 					}
// 				},
// 				{
// 					breakpoint: 0,
// 					settings: {
// 						slidesToShow: 2,
// 						slidesToScroll: 2,
// 						variableWidth: false,
// 					}
// 				}
// 			]
// 		});
// 	}
// 	getItem(item: instaItem): string {
// 		return `
// 			<div class="tp-Insta_Item">
// 				<a href="${item.permalink}" target="_blank" class="tp-Insta_Item_Link">
// 					<span class="tp-Insta_Item_Author">@${item.username}</span>
// 					<span class="tp-Insta_Item_Media">
// 						<img src="${item.thumbnail_url ? item.thumbnail_url : item.media_url}" alt="" width="206" height="206">
// 					</span>
// 				</a>
// 			</div>
// 		`;
// 	}
// }
require("jquery.cookie");
var Modal = /** @class */ (function () {
    function Modal() {
        if (!$.cookie('OCRTopModal')) {
            $.cookie('OCRTopModal', 'isOpened', { expires: 1 });
            $.fancybox.open({
                src: '#OCModal'
            });
        }
        ;
        // $.fancybox.open({
        // 	src: '#OCModal'
        // });
    }
    return Modal;
}());
